var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('window-header'),_c('nav-form',{scopedSlots:_vm._u([{key:"actions",fn:function(){return [(_vm.itemId)?_c('li',{on:{"click":function($event){return _vm.exportarLineasCSV('albaran_id')}}},[_vm._v(" Exportar líneas ")]):_vm._e()]},proxy:true},{key:"reports",fn:function(){return [_vm._l(((_vm.app.config.plantillas_documento_albaran_proveedor || [])),function(p){return _c('li',{key:'pdpc-' + p.codigo,class:{ disabled: !_vm.itemId },on:{"click":function($event){return _vm.openURL(_vm.app.urlGeneradorInformesDocumentoPrint, { id: p.codigo, conditions: [['id', '=', _vm.itemId]] })}}},[_vm._v(" Documento: "+_vm._s(p.nombre)+" ")])}),_vm._l(((_vm.app.config.plantillas_etiqueta_albaran_proveedor || [])),function(p){return _c('li',{key:'pdpc-' + p.codigo,class:{ disabled: !_vm.itemId },on:{"click":function($event){return _vm.openURL(_vm.app.urlGeneradorInformesEtiquetaPrint, { id: p.codigo, conditions: [['id', '=', _vm.itemId]] })}}},[_vm._v(" Etiquetas: "+_vm._s(p.nombre)+" ")])})]},proxy:true}])}),_c('section',[_c('article',{staticStyle:{"height":"395px"}},[_c('field',{staticStyle:{"top":"5px","left":"5px"},attrs:{"name":"ndoc","widget":"char","searchable":"","label":"Nº Fabricación","width":"110px","inputStyle":"text-align:right;"}}),_c('field',{staticStyle:{"top":"5px","left":"130px"},attrs:{"name":"fecha","type":"date","label":"Fecha","width":"100px"}}),_c('field',{ref:"proveedor_id",staticStyle:{"top":"5px","right":"55px"},attrs:{"autofocus":"","name":"proveedor_id","widget":"m2o","label":"Taller","searchable":"","width":"320px","labelProp":"nombre_comercial","imgProp":"imagen.imagen","filter":[['activo', '=', 1], ['realiza_reparaciones', '=', 1]],"fields":[
          'nacionalidad',
          { name: 'divisa_id', fields: ['codigo', 'nombre', 'ratio'] },
          { name: 'impuesto_id', fields: ['nombre', 'valor'] },
          'descuento_especial',
          'financiacion',
          { name: 'comentarios', fields: ['descripcion', 'fecha', 'activo'] },
          {
            name: 'forma_pago_id',
            fields: [
              'codigo',
              'descripcion',
              'vencimientos',
              'periodicidad',
              'periodicidad_unidades' ],
          },
          'descuento_linea_unidad',
          'descuento_linea_peso',
          'merma',
          'merma_linea'
        ]}}),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Mostrar comentarios'),expression:"'Mostrar comentarios'"}],staticClass:"button button-plain",class:{ disabled: !_vm.formData.proveedor_id },staticStyle:{"position":"absolute","top":"15px","right":"22px"},attrs:{"href":"#"},on:{"click":_vm.mostrarComentariosProveedor}},[_c('fa-icon',{attrs:{"icon":"sticky-note"}})],1),_c('r-tabs',{ref:"main-tabs",staticStyle:{"top":"40px","height":"353px"},attrs:{"wt":_vm.formData.wt,"buttons":[
        'Modelos a fabricar',
        'Pie' ],"classButton":{
        disabled: !_vm.formData.proveedor_id && _vm.mode != 'search',
      }},on:{"active":_vm.onActiveTab}},[_c('div',{staticClass:"tab"},[_c('field',{ref:"lineas",staticClass:"lineas",staticStyle:{"top":"5px","left":"4px","width":"648px"},attrs:{"name":"lineas","htSettings":{
            rowHeights: 15
          },"widget":"handsontable","height":152,"minRows":8,"customprop":"lineas_customprop","fields":[{ name: 'sublineas', fields: ['tipo', 'codigo', 'descripcion', 'unidades', 'peso', 'v', 'precio_coste', 'totallinea', 'peso_18k', 'precio_18k', { name: 'metal_id', fields: ['factor', 'cotizacion', 'codigo', 'metal'] }] }],"columns":[
              {
                name: 'ean13',
                header: '|||||||||',
                help: 'Código de barras del artículo',
              },
              {
                name: 'modelo_id',
                header: 'Modelo',
                help: 'Modelo del artículo',
                type: 'm2o',
                primary: 'codigo',
                label: 'codigo',
              },
              {
                name: 'articulo_id',
                header: 'Artículo',
                help: 'Código del artículo',
                type: 'm2o',
                primary: 'codigo',
                label: 'codigo',
                noOpen: true,
                fields: [
                  { name: 'thumbnail', fields: ['imagen'] },
                  { name: 'familia_id', fields: ['codigo', 'nombre'] } ],
              },
              {
                name: 'descripcion',
                help: 'Descripción del artículo',
                header: 'Descripción',
              },
              /*{
                name: 'refproveedor',
                header: 'R. Proveedor',
                help: 'Ref. del proveedor del artículo',
              },
              //{name:'familia_id',header:'Familia', type:'m2o', primary:'codigo', label:'codigo', readOnly:true},
              { name: 'nota', header: 'Nota' },*/
              //{name:'tt',header:'T', type:'select', options:['A','R']},
              {
                name: 'almacen_id',
                header: 'Almacén',
                help: 'Almacén',
                type: 'm2o',
                primary: 'codigo',
                label: 'codigo',
                readOnly: true,
              },
              {
                name: 'unidades',
                header: 'Unid.',
                help: 'Unidades',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'etiqueta',
                help: 'Etiquetas',
                header: 'Etiq.',
                type: 'numeric',
              },
              {
                name: 'peso',
                header: 'Peso',
                help: 'Peso',
                type: 'numeric',
                numericFormat: { pattern: '0,0.000' },
              },
              {
                name: 'v',
                header: 'V',
                help: '<U> Venta por unidad <P> Venta por peso',
                type: 'select',
                options: ['U', 'P'],
              },
              {
                name: 'm',
                header: 'M',
                help: 'Venta con metal incluido',
                type: 'checkbox',
              },
              {
                name: 'precio_coste',
                header: 'P. Coste',
                help: 'Precio de coste del artículo',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'margen',
                header: '%',
                help: '% de Margen comercial',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'pventa',
                header: 'P.Venta',
                help: 'Precio de Vta. al cliente',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'tarifa',
                header: 'T',
                help: 'Tarifa en la que se grabará el P.Venta',
                type: 'numeric',
                numericFormat: { pattern: '0,0' },
              }
            ]}}),_c('field',{ref:"sublineas",staticClass:"lineas",staticStyle:{"top":"156px","left":"4px","width":"648px"},attrs:{"name":("lineas." + _vm.rowSelected + ".sublineas"),"readonly":_vm.rowSelected === null,"htSettings":{
              rowHeights: 15,
              cells: _vm.cellsSublineas,
            },"widget":"handsontable","height":152,"minRows":8,"columns":[
              {
                name: 'tipo',
                header: 'T',
                help: '<A> Artículo/materia prima <O> Otros costes',
                type: 'select',
                options: ['A', 'O'],
              },
              {
                name: 'codigo',
                header: 'Código'
              },
              {
                name: 'descripcion',
                help: 'Descripción del artículo',
                header: 'Descripción',
                readOnly: true,
              },
              {
                name: 'metal_id',
                header: 'Metal',
                type: 'm2o',
                primary: 'codigo',
                label: 'metal',
                model: 'metal',
                fields: ['factor', 'metal', 'cotizacion']
              },
              {
                name: 'peso_18k',
                header: 'Peso 18k',
                type: 'numeric',
                numericFormat: { pattern: '0,0.000' },
              },
              {
                name: 'precio_18k',
                header: 'Precio 18k',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'unidades',
                header: 'Unid.',
                help: 'Unidades',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'peso',
                header: 'Peso',
                help: 'Peso',
                type: 'numeric',
                numericFormat: { pattern: '0,0.000' },
              },
              {
                name: 'v',
                header: 'V',
                help: 'Valoración a <U> Unidad o a <P> Peso',
                type: 'select',
                options: ['U', 'P'],
              },

              {
                name: 'precio_coste',
                header: 'P. Coste',
                help: 'Precio de coste del artículo/trabajo',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'totallinea',
                header: 'Total',
                help: 'Total de la línea',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              } ]}})],1),_c('div',{staticClass:"tab"},[_vm._v(" "+_vm._s(_vm.formData && _vm.formData.lineas)+" "),_c('field',{staticStyle:{"top":"5px","right":"328px"},attrs:{"name":"total_unidades","widget":"float","type":"number","dec":"2","label":"Total Unidades","width":"70px","readonly":true}}),_c('field',{staticStyle:{"top":"5px","right":"250px"},attrs:{"name":"total_peso","widget":"float","type":"number","dec":"3","label":"Total Peso","width":"70px","readonly":true,"suffix":" g"}}),_c('field',{staticStyle:{"top":"10px","right":"12px"},attrs:{"name":"total_articulos","widget":"float","type":"number","dec":"2","label":"Total Artículos","inline-label":"","width":"70px","readonly":true}})],1)])],1)]),_c('v-collapse-wrapper',{ref:"main-collapse",attrs:{"active":true}},[_c('div',{directives:[{name:"collapse-toggle",rawName:"v-collapse-toggle"}],staticClass:"header"},[_vm._v(" Listado "),_c('div',{staticClass:"item-after"},[(_vm.years.length)?_c('field',{staticStyle:{"position":"relative","width":"100px","margin-right":"24px"},attrs:{"widget":"select","name":"anio","width":"100","options":_vm.years.reduce(function (a, v) {
                  var _obj;

                  return (Object.assign({}, a, ( _obj = {}, _obj[v] = v, _obj )));
}, {}),"searchable":"","readonly":_vm.mode != 'search',"placeholder":"Todos los años"},on:{"click":function($event){return $event.stopPropagation()}}}):_vm._e(),_vm._v(" "+_vm._s(_vm.count)+" ")],1)]),_c('div',{directives:[{name:"collapse-content",rawName:"v-collapse-content"}],staticClass:"my-content"},[_c('hot-table',{ref:"hotTableComponent",attrs:{"settings":_vm.htSettings}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }